export const SLIDER_MEDIA_THUMBNAIL_FORMAT = '136x136';
export const SLIDER_MEDIA_FORMAT = '1160x1160';
export const IMAGE_ACCEPTED_FORMAT = 'image/png,image/jpeg';
